import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { FACEBOOK_URL, ICEF_ACCOUNT_ID } from "./common/siteLinks";
import IcefBadge from "./common/IcefBadge";
import footerLogo from "../assets/images/img1.jpg";
import "./footerLayout.css";

const path = (value) => process.env.PUBLIC_URL + value;

const Footer = ({ withNewsletter = true }) => (
  <>
    <footer className={`footer1 ${withNewsletter ? "footer-with-newsletter" : "footer-standalone"}`}>
      <Container>
        <Row className="footer-grid">
          <Col lg="4" md="6">
            <div className="footer-brand">
              <Link to={path("/")}>
                <img src={footerLogo} alt="Study Concerns International" />
              </Link>
              <p>
                Expert guidance for admissions, scholarships, visas, and your
                complete international education journey.
              </p>
              <ul className="footer-contact list-unstyled">
                <li><i className="las la-envelope"></i>info@studyconcerns.com</li>
                <li><i className="las la-phone"></i>+1 (905) 622 1221</li>
                {/* <li><i className="las la-phone"></i>+92 (322) 202 2121</li> */}
              </ul>
              <IcefBadge accountId={ICEF_ACCOUNT_ID} />
            </div>
          </Col>

          <Col lg="2" md="6">
            <div className="footer-links">
              <h5>Useful Links</h5>
              <ul className="list-unstyled">
                <li><Link to={path("/general")}>General Info</Link></li>
                <li><Link to={path("/help-center")}>Help Center</Link></li>
                <li><Link to={path("/privacy-policy")}>Privacy Policy</Link></li>
                <li><Link to={path("/online-support")}>Online Support</Link></li>
              </ul>
            </div>
          </Col>

          <Col lg="3" md="6">
            <div className="footer-links">
              <h5>Explore</h5>
              <ul className="list-unstyled">
                <li><Link to={path("/about")}>About Us</Link></li>
                <li><Link to={path("/services")}>Our Services</Link></li>
                <li><Link to={path("/countries")}>Study Destinations</Link></li>
                <li><Link to={path("/contact")}>Contact Us</Link></li>
              </ul>
            </div>
          </Col>

          {/* <Col lg="3" md="6">
            <div className="footer-links footer-offices">
              <h5>Our Offices</h5>
              <p><i className="las la-map-marker"></i>Boyd Cres, Ajax, Ontario, Canada</p>
              <p><i className="las la-map-marker"></i>721 Block L, MA Johar Town, Lahore, Pakistan</p>
            </div>
          </Col> */}
        </Row>
      </Container>
    </footer>

    <section className="copyright-area">
      <Container>
        <Row className="align-items-center">
          <Col md="7">
            <p>Copyright &copy; {new Date().getFullYear()} Study Concerns International. All rights reserved.</p>
          </Col>
          <Col md="5">
            <ul className="footer-social list-unstyled list-inline">
              <li className="list-inline-item"><a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a></li>
              <li className="list-inline-item"><a href="https://www.instagram.com/" aria-label="Instagram"><i className="fab fa-instagram"></i></a></li>
              <li className="list-inline-item"><a href="https://www.linkedin.com/" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a></li>
              <li className="list-inline-item"><a href="https://www.youtube.com/" aria-label="YouTube"><i className="fab fa-youtube"></i></a></li>
            </ul>
          </Col>
        </Row>
      </Container>
      <BackToTop />
    </section>
  </>
);

export default Footer;
